import { createContext, useContext, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import api from '../services/api'

const CompanyContext = createContext(null)

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { companySlug } = useParams()

  useEffect(() => {
    if (!companySlug) {
      setLoading(false)
      return
    }

    const validateCompany = async () => {
      try {
        setLoading(true)
        const response = await api.get(`/validate/${companySlug}`)
        setCompany(response.data.company)
        setError(null)
      } catch (err) {
        setError('Company not found')
        setCompany(null)
      } finally {
        setLoading(false)
      }
    }

    validateCompany()
  }, [companySlug])

  const value = {
    company,
    loading,
    error,
    isValid: !!company
  }

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  )
}

export function useCompany() {
  const context = useContext(CompanyContext)
  if (!context) {
    throw new Error('useCompany must be used within CompanyProvider')
  }
  return context
}
